import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [showLanguagePopup, setShowLanguagePopup] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem('preferred-language');
    
    if (!savedLang) {
      // First time visitor - show language selection popup
      setTimeout(() => setShowLanguagePopup(true), 500);
    } else {
      // Returning visitor - use saved language
      setCurrentLanguage(savedLang);
    }
  }, []);

  const switchLanguage = (lang) => {
    setCurrentLanguage(lang);
    localStorage.setItem('preferred-language', lang);
    setShowLanguagePopup(false);
  };

  const t = (en, vi) => {
    return currentLanguage === 'vi' ? vi : en;
  };

  const value = {
    currentLanguage,
    switchLanguage,
    t,
    showLanguagePopup,
    setShowLanguagePopup
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};